export { default as AdjustmentsAltSolidIcon } from './AdjustmentsAltSolidIcon';
